<script>
  import settings from '../config';
  import session from '../lib/session';

  // component options  ------------------------------------------------------ //

  export let avatar;
  export let role;
  export let message;
  export let group = false;
  export let last_role;
  export let name = undefined;
  export let sender_id;
</script>

<div
  class="chat-message {role}"
  class:message-group-element={group}
  class:right-side={$session.user.id === sender_id}>

  {#if avatar === false}
    <span class="chat-message__avatar-frame" style="margin-top: -8px;">
      <img alt="avatar" class="chat-message__avatar-hidden" />
    </span>
    {#if !!message}
    {#if message.text !== null}
      <p
        class="chat-message__text"
        style="border-radius: 18px;"
        class:right-side={$session.user.id === sender_id}>
        {message.text}
      </p>
    {:else if message.image_url !== null}
      <div style=''>
        <img src={message.image_url}
             class="chat-image"
             onclick="window.open(this.src)"/>
      </div>
    {/if}
      {/if}
  {:else}
    <span class="chat-message__avatar-frame">
      <img
        src={`${settings.api_host}${avatar}`}
        alt="avatar"
        class="chat-message__avatar" />
    </span>
    {#if !!message}
      {#if message.text !== null}
        <p
          class="chat-message__text"
          class:right-side={$session.user.id === sender_id}>
          {message.text}
        </p>
      {:else if message.image_url !== null}
        <div style=''>
          <img src={message.image_url}
               class="chat-image"
               onclick="window.open(this.src)"/>
        </div>
      {/if}
    {/if}
  {/if}

</div>

<style type="text/scss">
  $avatar-size: 50px;

  .board-message__name {
    margin-top: 8px;
    font-size: 0.8em;
    font-weight: normal;
    color: #727b80;
    margin-left: 8px;
    margin-right: 8px;
    display: flex;
  }

  .chat-image {
    display: block;
    max-width: 366px;
    width: 100%;
    min-width: 200px;
    cursor: pointer;
  }

  .chat-message {
    display: flex;
    align-items: center;
    width: 100%;

    transition: all 0.5s;

    /* Other user variation*/
    &--right {
      flex-direction: row-reverse;

      .chat-message__text {
        background: var(--worker-background-color);
        background: var(--worker-background-color);
        color: #fff;
      }

      .chat-message__avatar-frame {
        margin-left: 16px;
        margin-right: 0;
      }
    }
  }

  /* Add more space when users alternate*!*/
  .chat-message + .chat-message--right,
  .chat-message--right + .chat-message {
    margin-top: 32px;
  }

  /* Handle consecutive messages:
    / Remove extra space
    / Hide avatar */

  .chat-message:not(.chat-message--right)
    + .chat-message:not(.chat-message--right),
  .chat-message--right + .chat-message--right {
    margin-top: 0;

    .chat-message__avatar-frame {
      visibility: hidden;
      opacity: 0;
    }
  }

  .chat-message__avatar-frame {
    display: flex;
    align-items: center;
    justify-content: center;
    width: $avatar-size;
    height: $avatar-size;
    border-radius: 50%;
    overflow: hidden;
    margin-top: -7px;
    margin-right: 16px;
    margin-left: 16px;
  }

  .chat-message__user-name {
    /*text-transform: uppercase;*/
    font-weight: 500;
    font-size: 13px;
    margin-bottom: 0;
    margin-top: 5px;
  }

  .chat-message__avatar {
    height: 100%;
  }

  .chat-message__avatar-hidden {
    opacity: 0;
  }

  .chat-message__text {
    white-space: pre-wrap;
    display: block;
    max-width: 65%;
    background: var(--orderer-background-color);
    background: var(--orderer-background-color);
    border-radius: 14px;
    box-sizing: border-box;
    padding: 12px 16px;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-weight: 300;
    color: #fff;
    margin: 0 1em;
    animation-duration: 0.3s;
    animation-name: slide-in;
    word-break: break-word;
    border-radius: 0px 18px 18px 18px;
  }

  .worker .chat-message__text {
    background: var(--worker-background-color);
    background: var(--worker-background-color);
    //border-radius: 18px 0 18px 18px;
  }

  .applicant .chat-message__text {
    background: var(--worker-background-color);
    background: var(--worker-background-color);
    //border-radius: 18px 0 18px 18px;
  }

  .orderer .chat-message__text {
    background: var(--orderer-background-color);
    background: var(--orderer-background-color);
    //border-radius: 0 18px 18px 18px;
  }

  .chat-message {
    display: flex;
  }

  .worker.chat-message {
    //flex-direction: row-reverse;
  }

  .right-side {
    border-radius: 18px 0 18px 18px;
  }

  .right-side.chat-message {
    flex-direction: row-reverse !important;
  }

  .right-side.board-message__name {
    flex-direction: row-reverse !important;
  }

  @keyframes slide-in {
    0% {
      transform: scale(0.85) translateY(10%);
      opacity: 0;
    }
    100% {
      transform: scale(1) translateY(0);
      opacity: 1;
    }
  }
</style>
